export default "__VITE_ASSET__CojKEr$n__"